export { AccountOpeningV2BeneficiaryAllocationsStep } from './AccountOpeningV2BeneficiaryAllocationsStep';
